import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.8583 19.8958C4.36058 19.3796 4.38432 18.5658 4.91131 18.0783L11.8602 11.6494L4.91131 5.22047C4.38432 4.73291 4.36058 3.91917 4.8583 3.40294C5.35601 2.8867 6.1867 2.86345 6.7137 3.35101L14.6729 10.7146C14.9354 10.9575 15.0842 11.2956 15.0842 11.6494C15.0842 12.0031 14.9354 12.3412 14.6729 12.5841L6.7137 19.9477C6.18671 20.4353 5.35601 20.412 4.8583 19.8958Z'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.1873 3C18.9121 3 19.4998 3.57563 19.4998 4.28571L19.4998 19.7143C19.4998 20.4243 18.9121 21 18.1873 21C17.4624 21 16.8748 20.4243 16.8748 19.7143L16.8748 4.28571C16.8748 3.57563 17.4624 3 18.1873 3Z'
            />
        </SvgIcon>
    );
});
